<template>
    <v-container fluid>
    <v-row>
      <!-- Earnings Summary -->
      <v-col cols="12" md="4" v-for="summary in earningsSummary" :key="summary.title">
        <v-card class="mb-4">
          <v-card-title>{{ summary.title }}</v-card-title>
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col class="text-center">
                <v-icon large color="primary">{{ summary.icon }}</v-icon>
                <div class="headline">{{ summary.value }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Earnings Details Table -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            {{ $t('userEarnings.earningsDetails') }}
            <v-spacer></v-spacer>
            <v-btn icon @click="refreshEarnings">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="earnings"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon @click="viewEarning(item)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  </template>
  
  <script>
  import { fetchUserEarnings } from '@/api/apiService';

  export default {
    name: 'UserEarnings',
    data() {
      return {
        todayRewards: '',
        totalRewards: '',
        yesterdayRewards: '',
        totalMembers: 0,
        totalDeposits: '',
        earnings: [],
        loading: false,
      };
    },
    props: {
      walletConnect: {
        type: Object,
        required: true
      }
    },
    computed: {
      earningsSummary() {
        const currentLanguage = this.$i18n.locale;
        return [
          { title: this.$t('userEarnings.todayRewards', { lang: currentLanguage }), value: this.todayRewards, icon: 'mdi-cash' },
          { title: this.$t('userEarnings.totalRewards', { lang: currentLanguage }), value: this.totalRewards, icon: 'mdi-cash-multiple' },
          { title: this.$t('userEarnings.yesterdayRewards', { lang: currentLanguage }), value: this.yesterdayRewards, icon: 'mdi-cash' },
        ];
      },
      headers() {
        const currentLanguage = this.$i18n.locale;
        return [
          { title: this.$t('userEarnings.userName', { lang: currentLanguage }), value: 'userName' },
          { title: this.$t('userEarnings.quantity', { lang: currentLanguage }), value: 'quantity' },
          { title: this.$t('userEarnings.time', { lang: currentLanguage }), value: 'time' },
          { title: this.$t('userEarnings.actions', { lang: currentLanguage }), value: 'actions', sortable: false },
        ];
      }
    },
    methods: {
      async loadEarnings(page = 1) {
        console.log(this.walletConnect.usdtContract, 'usdtContract 12');
          let decimals = await this.walletConnect.usdtContract.methods.decimals().call();
          decimals = Number(decimals);
          console.log("usdt decimal", decimals);
          this.loading = true;
          fetchUserEarnings(page).then(response => {
            console.log(response.data, "response.data");
            this.earnings = response.data.data.earnings;
            this.earnings.map(d=> {
              d.amount = Number(d.amount) / (10 ** decimals);
              d.total = Number(d.total) / (10 ** decimals);
            });
            this.todayRewards = response.data.data.todayRewards / 10**decimals;
            this.totalRewards = response.data.data.totalRewards / 10**decimals;
            this.yesterdayRewards = response.data.data.yesterdayRewards / 10**decimals;
            // this.totalMembers = response.data.data.totalMembers;
            // this.totalDeposits = response.data.data.totalDeposits;
            this.loading = false;
          });
      },
    },
    mounted() {
      this.$eventBus.on("walletConnectInitialized", () => {
        console.log("eventBus walletConnectInitialized");
        if(this.walletConnect.usdtContract) {
          this.loadEarnings();
        }
      });
    },
  };
  </script>
  
  <style scoped>
  .earnings-container {
    /* Styles */
  }
  .summary-card {
    background-image: url('@/assets/images/user/Credit-Card_bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  </style>
